import { apiCall } from './config';

export default {
  getCurrentUserAccountInfo: () => apiCall('v1/partnerportal/profile', 'GET'),
  updateCurrentUserAccountInfo: payload =>
    apiCall('v1/partnerportal/profile', 'PATCH', { body: payload })
};
